import { AccessReportsServiceArea, AccessReportsWizardOption } from "@app/access-reports/shared";

class AccessReportsWizardProviderCountPage {
  columns: AccessReportsWizardOption[];
  filteredWithinServiceArea: AccessReportsWizardOption;
  hasServiceArea: boolean;
  id: number;
  providerCount: boolean;
  providerGroupIds: number[];
  serviceArea: AccessReportsServiceArea;
  summarizeBy: AccessReportsWizardOption;

  constructor(providerCount: boolean, id: number) {
    this.columns = [];
    this.filteredWithinServiceArea = null;
    this.hasServiceArea = false;
    this.id = id;
    this.providerCount = providerCount;
    this.providerGroupIds = [];
    this.serviceArea = null;
    this.summarizeBy = null;
  }
}

export { AccessReportsWizardProviderCountPage };
